<template>
  <div class="animated fadeIn">
    <div class="container py-5">
      <b-row class="justify-content-center">
        <b-col cols="12" md="8" lg="6">
          <b-card class="text-center shadow">
            <div class="mb-4 success-icon-animate">
              <font-awesome-icon :icon="['fal', 'check-circle']" size="5x" class="text-success" />
            </div>

            <h2 class="text-primary mb-3">{{ $t("Webportal.Actions.SurveyRevision.ProcessingNote.Title") }}</h2>

            <p
              class="text-muted mb-4"
              v-html="
                $t('Webportal.Actions.SurveyRevision.ProcessingNote', { url: $router.resolve({ name: 'Notification settings' }).href })
              "
            ></p>

            <b-button variant="primary" block class="mb-2" @click="goToOverview">
              <font-awesome-icon :icon="['fal', 'list']" class="mr-2" />
              {{ $t('Webportal.Overview') }}
            </b-button>

            <b-button variant="secondary" block @click="createNewInquiry">
              <font-awesome-icon :icon="['fal', 'plus']" class="mr-2" />
              {{ $t('Webportal.Actions.InquiryWizard.Success.CreateNew') }}
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "InquirySuccess",

  methods: {
    goToOverview() {
      this.$store.dispatch("inquiryWizard/resetWizard");
      this.$router.push({ name: "SurveyRevisionExplorer" });
    },

    createNewInquiry() {
      this.$store.dispatch("inquiryWizard/resetWizard");
      this.$router.push({ name: "InquiryLanding" });
    },
  },
};
</script>

<style lang="scss" scoped>
.success-icon-animate {
  animation: scaleIn 0.5s ease-out;
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
